import React from 'react'
import TestimonialsSection from '@/components/blocks/testimonials-section'
import { listPublicTestimonials } from '../services/testimonialsService'

export default function TestimonialsMarqueeHome() {
  const [items, setItems] = React.useState<any[]>([])
  const [loading, setLoading] = React.useState(true)

  React.useEffect(() => {
    let mounted = true
    ;(async () => {
      try {
        setLoading(true)
        const data = await listPublicTestimonials(24)
        if (!mounted) return
        const mapped = data.map((d) => ({
          author: { name: d.author_name, handle: d.author_handle ?? '', avatar: d.avatar_url || '/avatar.png' },
          text: d.text,
          href: d.href || undefined,
        }))
        setItems(mapped)
      } catch {
        if (mounted) setItems([])
      } finally {
        if (mounted) setLoading(false)
      }
    })()
    return () => { mounted = false }
  }, [])

  if (loading || items.length === 0) return null

  return (
    <TestimonialsSection
      title="O que dizem sobre o Cripto Alert"
      description="Feedback real de traders e analistas que usam a plataforma diariamente."
      testimonials={items}
    />
  )
}

